import { css, jsx } from '@emotion/core';
import { Collapse, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import { bp, colors } from '@/styles';

import AccordionPanel from './Components/contents/AccordionPanel';

const style = {
  accordion: css`
    margin-left: -16px;
    margin-right: -16px;
    background-color: transparent;
    border-bottom: none;
    @media ${bp.sm} {
      margin-left: 0;
      margin-right: 0;
    }
  `,
  innerPanelContainer: css``,
  panel: css`
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    border-radius: 2px;
    margin-bottom: 16px;
    background-color: white;
    border-bottom: none !important;
    .ant-collapse-content {
      .ant-collapse-content-box {
        padding: 0;
      }
    }
    .ant-collapse-header {
      padding: 31px 16px 31px 72px !important;
      font-weight: 900;
      font-size: 2rem;
      line-height: 3.2rem !important;
      color: ${colors.primaryBlue} !important;
      &[aria-expanded='true'] {
        color: ${colors.primaryRed} !important;
      }
      .anticon {
        font-size: 2.6rem !important;
        margin-left: 12px;
      }
      .ant-collapse-content {
        border-bottom: 0;
      }
      & + div .ant-collapse-header {
        font-size: 1.8rem;
        line-height: 3rem;
      }
      @media ${bp.md} {
        font-size: 2.8rem;
        line-height: 3.6rem;
        & + div .ant-collapse-header {
          font-size: 2rem;
          line-height: 3.2rem;
        }
      }
    }
  `,
};

const { Panel } = Collapse;

const Accordion = ({ blockData, entities }) => {
  let blockComponents = [];
  if (blockData.Components && Array.isArray(blockData.Components)) {
    blockComponents = blockData.Components.map(c => entities.Components[c]);
  }
  return (
    <div>
      <Collapse
        accordion
        bordered={false}
        expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0} />}
        className="outerpanel"
        css={style.accordion}
      >
        {blockComponents.map((panel, i) => {
          const { Title, Contents } = panel;
          let componentContents = [];
          if (Contents && Array.isArray(Contents)) {
            componentContents = Contents.map(c => entities.Contents[c]);
          }
          return (
            <Panel
              // eslint-disable-next-line
              key={`accordion-panel-${panel.BlockComponentId}`}
              header={Title}
              css={style.panel}
            >
              <div css={style.innerPanelContainer}>
                {componentContents.map(c => (
                  <AccordionPanel contentData={c} key={c.ComponentContentId} entities={entities} />
                ))}
              </div>
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
};

Accordion.propTypes = {};

Accordion.defaultProps = {
  panels: [],
};
export default Accordion;
